import { appClient } from '@/lib/appwrite/appClient';
import { APP_COLLECTIONS } from '@polybank/shared';
import { ID, Permission, Role } from 'appwrite';

class WaitlistService {
  async submitToWaitlist(email: string, source = 'landing_page') {
    const permissions = [Permission.read(Role.any())];

    return appClient.tables.typed.createRow(
      APP_COLLECTIONS.WAITLIST,
      ID.unique(),
      {
        email,
        source,
        subscribed_at: new Date().toISOString(),
      },
      permissions
    );
  }
}

export const waitlistService = new WaitlistService();
